import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { NodeType } from "./Models/NodeType";

export default NodeDeleteDialog;

function NodeDeleteDialog(props) {
  const { node, onDirectDelete, onCascadeDelete, onClose } = props;

  const handleDelete = () => {
    const { type } = node;

    type === NodeType.CONDITIONAL
      ? onCascadeDelete(node)
      : onDirectDelete(node);

    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Delete {node.data.name}?</DialogTitle>
      <DialogBody></DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handleDelete}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
